import React from "react";
import { Link } from "react-router-dom";

const CourseCard = ({
  row,
  item,
}) => {
  return (
    <Link to={"/course/" + item.id} className="challenge js-challenge">
      <span className="background"></span>
      <span className="topic">
        <span className="number">Price: {item.price} coin</span>
        <span className="name">{item.name}</span>
        {/* <span className="status">Winners</span> */}
      </span>
      <span className="preview">
        <div className="media-container">
          {/* <video
            className="video js-video"
            src="https://media.bemamnon.com/NumberBlocks/Level%201%20Numbers%20up%20to%205/Numberblocks_S01E01_One.mp4"
            width="480"
            height="270"
            muted
            loop
            autoPlay
          ></video> */}
          <img src={item.thumbnailUrl} width="480" height="270" alt="" />
          <div className="gradient"></div>
          <div className="title-author">
            <div className="title">{item.totalLessons} lessions</div>
            {/* <div className="author mt-1">Tổng thời lượng: {item.totalHours} giờ</div> */}
          </div>
        </div>
        <span className="bottom-label">
          See more
          <span className="arrow">
            <svg
              width="11"
              height="7"
              viewBox="0 0 11 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.5 7C5.10218 7 4.72064 6.84197 4.43934 6.56066L0.439339 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.439339 0.43934C1.02513 -0.146446 1.97487 -0.146446 2.56066 0.43934L5.5 3.37868L8.43934 0.43934C9.02513 -0.146447 9.97487 -0.146447 10.5607 0.439339C11.1464 1.02513 11.1464 1.97487 10.5607 2.56066L6.56066 6.56066C6.27936 6.84197 5.89782 7 5.5 7Z"
                fill="white"
              />
            </svg>
          </span>
        </span>
      </span>
    </Link>
  );
};

export default CourseCard;
